namespace advisorop.components.advisor {
    
    export class PopHhrInvestmentsController {
        // bindings
        hhrAccount: domains.IHhrAccount;
        household: domains.IHousehold;

        // bindings inherited from modal
        modalInstance: any; //angular.ui.bootstrap.IModalServiceInstance

        proposal: domains.IProposal;
        cuProposalController: components.common.CuProposalController;


        static $inject = ["advisorService", "generalService", "$scope"];
        constructor(
            private advisorService: advisorop.services.AdvisorService,
            private generalService: advisorop.services.GeneralService,
            private $scope: ng.IScope
        ) {
        }

        bindCuProposal(ctrl: components.common.CuProposalController): void {
            this.cuProposalController = ctrl;
        };
        proposalCreated(proposal: domains.IProposal): void {
            this.proposal = proposal;
        };
        accountStatusChanged(status: boolean): void {
        };
        skippingOptionChecked(isDiscretionDocumentationOnFile: boolean): void {
        }
        proposalSigned(proposal: domains.IProposal): void {
            // toastr.info("Proposal has been signed! Now you can activate account!");
            this.proposal = proposal; //signed
            this.proposal.signedReportFileName = proposal.signedReportFileName;
            // this.doStep(true);
        };


        
        // default modal methods
        ok = () => {
            //console.log("PopHhrInvestments ok() function fired...");

            const $resolve = this.$scope.$parent.$resolve;

            const modal = (this.$scope.$parent.$uibModalInstance as angular.ui.bootstrap.IModalServiceInstance);

            modal.close(this.hhrAccount);
        };

        cancel = () => {
            this.$scope.$parent.$uibModalInstance.dismiss();
        };

        
        // overrides
        $onInit(): void {
            // initialise modal
            const $resolve = this.$scope.$parent.$resolve;

            this.household = $resolve.household;

            var promAcc = $resolve.account;
            
            //console.log("Resolved account: ", promAcc);

            this.hhrAccount = $resolve.account;
        }
    }

    class PopHhrInvestments implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = PopHhrInvestmentsController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/pop-hhr-investments.html";
        }
        
    }
    angular.module(Constants.APP).component("popHhrInvestments", new PopHhrInvestments());
}